import type { StateStorage } from 'zustand/middleware'

import { dataBase, objectStoreName } from './iDataBase'

export const persistStorage = {
    async getItem(key: string) {
        return (await dataBase).get(objectStoreName, key)
    },
    async setItem(key: string, value: string) {
        ;(await dataBase).put(objectStoreName, value, key)
    },
    async removeItem(key: string) {
        ;(await dataBase).delete(objectStoreName, key)
    },
} satisfies StateStorage
